import { ChevronsLeft, ChevronsRight } from "lucide-react";
import { Brand } from "./Brand";
import { NavLinks } from "./NavLinks";
import { L } from "@/i18n";

export const Sidebar = ({ collapsed, onToggle }) => (
  <aside
    data-testid="sidebar"
    className={`hidden md:flex fixed inset-y-0 left-0 z-40 flex-col bg-[#091120] border-r border-slate-800/80 transition-[width] duration-300 ease-in-out ${
      collapsed ? "w-20" : "w-64"
    }`}
  >
    <div className={`h-16 flex items-center border-b border-slate-800/80 ${collapsed ? "justify-center px-2" : "px-5"}`}>
      <Brand compact={collapsed} />
    </div>
    <div className="flex-1 overflow-y-auto px-3 py-6">
      {!collapsed && (
        <p className="px-3 mb-3 text-[10px] font-mono uppercase tracking-[0.2em] text-slate-500">{L("Navigation", "Navegação")}</p>
      )}
      <NavLinks collapsed={collapsed} />
    </div>
    <button
      type="button"
      onClick={onToggle}
      data-testid="sidebar-toggle-button"
      className="m-3 flex items-center justify-center gap-2 rounded-md border border-slate-800 py-2 text-xs text-slate-400 hover:text-amber-400 hover:border-amber-500/40 transition-colors"
    >
      {collapsed ? <ChevronsRight className="h-4 w-4" /> : <ChevronsLeft className="h-4 w-4" />}
      {!collapsed && <span>{L("Collapse", "Recolher")}</span>}
    </button>
  </aside>
);
